module.exports = __webpack_public_path__ + "bv-logo-white.d29bda4d150c958be80c3f26c02c27a6.svg";